import { Injectable } from '@angular/core';
import { DLModels, DLNames } from '../../../assets/data/DLModels';
import { DlProgram, DlScheduleService } from './dl-schedule.service';

export interface DLModelResolved {
  modelCode: string;
  modelName: string;
  version: string;
  description: string;
  languages: string[];
}

@Injectable({ providedIn: 'root' })
export class DlDataService {

  constructor(private _dlSchedule: DlScheduleService) {}

  getModelData(modelCode: string): DLModelResolved | null {
    const model = DLModels.find(
      (m) => String(m.Modelo).toUpperCase() === String(modelCode).toUpperCase()
    );

    if (!model) return null;

    const nameEntry = DLNames.find((n) => n.name === model.name);

    return {
      modelCode: model.Modelo,
      modelName: model.name,
      version: model.Ver,
      description: model.description,
      languages: nameEntry?.languages || [],
    };
  }

  formatProgramData(programData: any): DlProgram[] {
    return this._dlSchedule.parsePrograms(programData);
  }

  formatCalendarStatus(stat: any) {
    if (!stat) return null;

    return {
      raw: stat,
      hour: stat[0],
      minute: stat[1],
      seconds: stat[2],
      weekday: stat[3],
      day: stat[4],
      month: stat[5],
      year: stat[6],
      dateStr: `${this.pad2(stat[4])}/${this.pad2(stat[5])}/${stat[6]}`,
      timeStr: `${this.pad2(stat[0])}:${this.pad2(stat[1])}`,
      dateTimeStr: `${this.pad2(stat[4])}/${this.pad2(stat[5])}/${stat[6]} ${this.pad2(stat[0])}:${this.pad2(stat[1])}:${this.pad2(stat[2])}`,
    };
  }

  private pad2(value: number): string {
    return String(value).padStart(2, '0');
  }
}
